import styled from 'styled-components';
import { colors } from 'globalStyles';
import { media } from 'utils/style-utils';

export const Wrapper = styled.div`
  font-size: 14px;
  line-height: 20px;
`;

export const Menu = styled.div`
  padding: 28px 60px 0 40px;
  display: flex;
  justify-content: space-between;
  color: ${colors.BODY};
  ${media.mobile`
    padding: 20px 20px 0 20px;

  `}
`;

export const RightNavContent = styled.div`
  margin: auto 0;

  >a {
    ${media.mobile`
      >span {
        display: none;
      }
    `}
  }
`;

export const Button = styled.button`
  margin-left: 27px;
  width: 140px;
  height: 36px;
  border: 1px solid ${colors.MAIN_COLOR};
  border-radius: 100px;
  color: ${colors.MAIN_COLOR};

  font-size: 12px;
  font-weight: bold;
  line-height: 17px;
  text-align: center;
    &.active,
    &:hover,
    &:active {
      background: ${colors.BUTTON_BG};
      color: #fff;
      border: none;
    }



  ${media.mobile`
    margin-left: 0;
  `}
`;

export const Content = styled.div`
  ${({ divWidth }) => `
    width: ${divWidth}px
  `}
  margin: 0 auto;
  ${media.tablet`
    width: 71%;
    padding: 0 20px;
  `}
  ${media.mobile`
    width: 500px;
    padding: 0 20px;
  `}
  ${media.mobile_500`
    width: 100%;
  `}
`;




// WEBPACK FOOTER //
// ./src/components/GetStartedMenu/styledComponents.js